/* Basic Pro Move — interações do tema */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const T = window.theme || {};

  /* ---------- Dinheiro ---------- */
  function formatMoney(cents, format = T.moneyFormat || 'R$ {{amount_with_comma_separator}}') {
    const value = (Number(cents) || 0) / 100;
    const fmt = (n, dec, thou, sep) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_comma_separator':
        default: return fmt(value, 2, '.', ',');
      }
    });
  }
  const toast = (msg) => {
    let t = document.getElementById('BpToast');
    if (!t) { t = document.createElement('div'); t.id = 'BpToast'; t.className = 'bp-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._hide);
    t._hide = setTimeout(() => t.classList.remove('is-on'), 4000);
  };
  const pixPrice = (cents) => Math.floor(cents * (100 - (T.pixDiscount || 0)) / 100);
  function installments(cents) {
    let n = T.installments || 1;
    if (T.installmentMin > 0) n = Math.min(n, Math.floor(cents / T.installmentMin));
    n = Math.max(1, n);
    return n > 1 ? `${n}x de ${formatMoney(Math.floor(cents / n))}` : '';
  }

  /* ---------- Drawers (carrinho, filtros, menu) ---------- */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    document.documentElement.style.overflow = 'hidden';
    const focusable = el.querySelector('button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .mobile-menu.is-open')) { document.documentElement.style.overflow = ''; document.body.classList.remove('drawer-open'); }
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = e.target.closest('[data-drawer-close], [data-menu-close]');
    if (closer) closeDrawer(closer.closest('.drawer, .mobile-menu'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open, .mobile-menu.is-open').forEach(closeDrawer);
  });

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header) {
    const menuBtn = $('[data-menu-open]');
    if (menuBtn) menuBtn.addEventListener('click', () => openDrawer($('[data-mobile-menu]')));

    const searchBtn = $('[data-search-toggle]');
    const search = $('[data-search]');
    if (searchBtn && search) {
      const fields = $$('input, button', search);
      const setSearch = (open) => {
        search.classList.toggle('is-open', open);
        header.classList.toggle('search-open', open);
        search.setAttribute('aria-hidden', String(!open));
        searchBtn.setAttribute('aria-expanded', String(open));
        fields.forEach((f) => { if (f.type !== 'hidden') f.tabIndex = open ? 0 : -1; });
        if (open) setTimeout(() => $('input[type="search"]', search).focus(), 250);
      };
      searchBtn.addEventListener('click', () => setSearch(!search.classList.contains('is-open')));
      $('[data-search-close]', search).addEventListener('click', () => { setSearch(false); searchBtn.focus(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && search.classList.contains('is-open')) setSearch(false); });
      document.addEventListener('click', (e) => { if (search.classList.contains('is-open') && !search.contains(e.target) && !searchBtn.contains(e.target)) setSearch(false); });
    }

    /* Some ao descer, volta ao subir */
    let lastY = window.scrollY;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const busy = header.classList.contains('search-open') || header.matches(':hover') || $('.drawer.is-open, .mobile-menu.is-open');
        if (y > 180 && y > lastY + 6 && !busy) document.body.classList.add('header-hidden');
        else if (y < lastY - 6 || y <= 180) document.body.classList.remove('header-hidden');
        lastY = y;
        ticking = false;
      });
    }, { passive: true });

    if (header.classList.contains('is-sticky') && document.body.classList.contains('header-overlay')) {
      const onScroll = () => header.classList.toggle('is-scrolled', window.innerWidth > 989 && window.scrollY > 260);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- Barra de anúncios rotativa ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    let timer = null;
    const show = (n) => {
      const prev = items[i];
      i = (n + items.length) % items.length;
      if (prev === items[i]) return;
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      setTimeout(() => prev.classList.remove('is-leaving'), 460);
      items[i].classList.add('is-active');
    };
    const start = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), Number(bar.dataset.speed) || 4000); };
    const prevBtn = $('[data-ann-prev]', bar);
    const nextBtn = $('[data-ann-next]', bar);
    if (prevBtn) prevBtn.addEventListener('click', () => { show(i - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { show(i + 1); start(); });
    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- Hero slider ---------- */
  $$('[data-hero]').forEach((hero) => {
    const track = $('[data-hero-track]', hero);
    const slides = $$('.hero__slide', track);
    const dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    let index = 0;
    let timer = null;
    const delay = Number(hero.dataset.autoplay) || 0;

    const goTo = (i) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    };
    const sync = () => {
      index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    };
    const start = () => { if (delay > 0) { stop(); timer = setInterval(() => goTo(index + 1), delay); } };
    const stop = () => clearInterval(timer);

    $('[data-hero-prev]', hero).addEventListener('click', () => { goTo(index - 1); start(); });
    $('[data-hero-next]', hero).addEventListener('click', () => { goTo(index + 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { goTo(Number(d.dataset.heroDot)); start(); }));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  });

  /* ---------- Vídeos com produto ---------- */
  $$('[data-vshop]').forEach((section) => {
    const rail = $('[data-vs-rail]', section);
    if (!rail) return;
    const saveData = (navigator.connection && navigator.connection.saveData) || window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setupStories = (root) => {
      $$('[data-vs-story]', root).forEach((media) => {
        const video = $('video', media);
        if (!video || media.dataset.ready) return;
        media.dataset.ready = '1';
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!video.src && !saveData) video.src = video.dataset.src;
              if (video.src) video.play().then(() => media.classList.add('is-playing')).catch(() => {});
            } else if (video.src) {
              video.pause();
            }
          });
        }, { rootMargin: '200px 0px', threshold: 0.35 });
        io.observe(media);
        const mute = $('[data-vs-mute]', media);
        if (mute) mute.addEventListener('click', () => {
          if (!video.src) video.src = video.dataset.src;
          video.muted = !video.muted;
          mute.setAttribute('aria-pressed', String(video.muted));
          mute.setAttribute('aria-label', video.muted ? 'Ativar som' : 'Desativar som');
          video.play().then(() => media.classList.add('is-playing')).catch(() => {});
        });
      });
    };

    section.addEventListener('click', (e) => {
      const buy = e.target.closest('[data-vs-buy]');
      if (!buy) return;
      const prod = buy.closest('.vcard__prod');
      $$('.vcard__prod.is-open', section).forEach((p) => { if (p !== prod) p.classList.remove('is-open'); });
      prod.classList.toggle('is-open');
      buy.setAttribute('aria-expanded', prod.classList.contains('is-open'));
    });

    const step = () => (rail.children[0] ? rail.children[0].getBoundingClientRect().width + 16 : 300);
    let hold = 0;
    const pause = (ms) => { hold = performance.now() + ms; };
    const prev = $('[data-vs-prev]', section);
    const next = $('[data-vs-next]', section);
    if (prev) prev.addEventListener('click', () => { pause(2500); rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', () => { pause(2500); rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    const cards = Array.from(rail.children);
    if (section.dataset.autoplay === 'true' && cards.length > 1 && !saveData && rail.scrollWidth > rail.clientWidth + 4) {
      cards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        $$('a, button, video', clone).forEach((el) => el.setAttribute('tabindex', '-1'));
        $$('[data-vs-story]', clone).forEach((m) => { delete m.dataset.ready; m.classList.remove('is-playing'); });
        rail.appendChild(clone);
      });
      section.dataset.auto = 'on';
      const loopWidth = () => rail.children[cards.length].offsetLeft - rail.children[0].offsetLeft;
      const speed = Number(section.dataset.speed) || 35;
      const state = { hover: false, view: true };
      let pos = -1;
      let last = 0;
      let lastSet = -1;
      rail.addEventListener('pointerenter', (ev) => { if (ev.pointerType === 'mouse') state.hover = true; });
      rail.addEventListener('pointerleave', (ev) => { if (ev.pointerType === 'mouse') state.hover = false; });
      ['wheel', 'touchstart', 'pointerdown'].forEach((t) => rail.addEventListener(t, () => pause(1800), { passive: true }));
      rail.addEventListener('scroll', () => { if (lastSet >= 0 && Math.abs(rail.scrollLeft - lastSet) > 2) { pause(1500); pos = -1; } }, { passive: true });
      new IntersectionObserver((en) => { state.view = en[0].isIntersecting; }).observe(rail);
      const frame = (now) => {
        requestAnimationFrame(frame);
        if (state.hover || !state.view || document.hidden || now < hold || $('.vcard__prod.is-open', section)) { last = 0; lastSet = -1; return; }
        if (!last) { last = now; return; }
        const dt = Math.min((now - last) / 1000, 0.12);
        last = now;
        if (pos < 0) pos = rail.scrollLeft;
        pos += speed * dt;
        const lw = loopWidth();
        if (lw > 0) while (pos >= lw) pos -= lw;
        rail.scrollLeft = pos;
        lastSet = rail.scrollLeft;
      };
      requestAnimationFrame(frame);
    }
    setupStories(section);
  });

  /* ---------- Vídeos em bolinha na PDP (seção "Vídeos do produto", formato Bolinhas) ---------- */
  $$('[data-vbub]').forEach((section) => {
    const form = $('form[data-product-form]');
    const errorLine = form && form.nextElementSibling && form.nextElementSibling.matches('[data-form-error]') ? form.nextElementSibling : null;
    if (form) (errorLine || form).after(section);
    section.hidden = false;

    const items = $$('[data-vbub-open]', section);
    if (!items.length) return;
    const calm = (navigator.connection && navigator.connection.saveData) || window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Prévia: cada bolinha toca o próprio vídeo sem som quando aparece na tela
    if (!calm) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const v = $('video', entry.target);
          if (!v) return;
          if (entry.isIntersecting) {
            if (!v.src) v.src = v.dataset.previewSrc;
            v.play().then(() => entry.target.classList.add('is-playing')).catch(() => {});
          } else if (v.src) v.pause();
        });
      }, { threshold: 0.3 });
      items.forEach((b) => io.observe(b));
    }

    // Modal em tela cheia (um por página)
    let modal = $('.vbub-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'vbub-modal';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Vídeo');
      modal.innerHTML = '<div class="vbub-story">'
        + '<div class="vbub-story__bars" data-bars></div>'
        + '<video class="vbub-story__video" playsinline loop></video>'
        + '<button type="button" class="vbub-story__close" data-close aria-label="Fechar">&times;</button>'
        + '<button type="button" class="vbub-story__sound" data-sound aria-label="Desativar som">Som</button>'
        + '<button type="button" class="vbub-story__nav vbub-story__nav--prev" data-prev aria-label="Vídeo anterior"></button>'
        + '<button type="button" class="vbub-story__nav vbub-story__nav--next" data-next aria-label="Próximo vídeo"></button>'
        + '<div class="vbub-story__extra" data-extra></div>'
        + '</div>';
      document.body.appendChild(modal);
    }
    const video = $('video', modal);
    const extra = $('[data-extra]', modal);
    const bars = $('[data-bars]', modal);
    const sound = $('[data-sound]', modal);
    let list = [];
    let index = 0;
    let lastFocus = null;

    const setSound = (on) => {
      video.muted = !on;
      sound.textContent = on ? 'Som' : 'Sem som';
      sound.setAttribute('aria-label', on ? 'Desativar som' : 'Ativar som');
      sound.classList.toggle('is-muted', !on);
    };
    const show = (i) => {
      index = (i + list.length) % list.length;
      const btn = list[index];
      video.src = btn.dataset.src;
      const tpl = btn.parentElement.querySelector('template[data-vbub-extra]');
      extra.innerHTML = tpl ? tpl.innerHTML : '';
      bars.innerHTML = list.map((_, n) => '<i class="' + (n < index ? 'is-done' : n === index ? 'is-on' : '') + '"></i>').join('');
      video.play().catch(() => { setSound(false); video.play().catch(() => {}); });
    };
    const close = () => {
      modal.hidden = true;
      video.pause();
      video.removeAttribute('src');
      video.load();
      document.documentElement.classList.remove('vbub-lock');
      if (lastFocus) lastFocus.focus();
    };
    section.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-vbub-open]');
      if (!btn) return;
      list = items;
      lastFocus = btn;
      modal.hidden = false;
      document.documentElement.classList.add('vbub-lock');
      setSound(true);
      show(items.indexOf(btn));
      $('[data-close]', modal).focus();
    });
    if (!modal.dataset.ready) {
      modal.dataset.ready = '1';
      modal.addEventListener('click', (e) => {
        if (e.target.closest('[data-close]') || e.target === modal) return close();
        if (e.target.closest('[data-prev]')) return show(index - 1);
        if (e.target.closest('[data-next]')) return show(index + 1);
        if (e.target.closest('[data-sound]')) return setSound(video.muted);
        if (e.target.closest('[data-quick-add]')) setTimeout(close, 300); // a sacola abre por cima
      });
      document.addEventListener('keydown', (e) => {
        if (modal.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') show(index + 1);
        if (e.key === 'ArrowLeft') show(index - 1);
      });
      let x0 = null;
      modal.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      modal.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }
  });

  /* ---------- Faixa de categorias ---------- */
  $$('.catstrip').forEach((sec) => {
    const rail = $('[data-strip]', sec);
    const by = () => (rail.children[0] ? (rail.children[0].getBoundingClientRect().width + 14) * 2 : 300);
    const p = $('[data-strip-prev]', sec);
    const n = $('[data-strip-next]', sec);
    if (p) p.addEventListener('click', () => rail.scrollBy({ left: -by(), behavior: 'smooth' }));
    if (n) n.addEventListener('click', () => rail.scrollBy({ left: by(), behavior: 'smooth' }));
  });

  /* ---------- Benefícios (mobile: um por vez) ---------- */
  $$('[data-benefits]').forEach((list) => {
    const items = $$('.benefit', list);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      if (window.innerWidth > 989) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3000);
  });

  /* ---------- Carrosséis ---------- */
  function initCarousel(root) {
    const track = $('[data-carousel-track]', root);
    const prev = $(':scope > [data-carousel-prev]', root);
    const next = $(':scope > [data-carousel-next]', root);
    if (!track) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    const step = () => {
      const first = track.children[0];
      if (!first) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const card = first.getBoundingClientRect().width + gap;
      return Math.max(card, Math.floor(track.clientWidth / card) * card);
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- Galeria do produto ---------- */
  $$('[data-product]').forEach((section) => {
    const track = $('[data-gallery] [data-carousel-track]', section);
    const thumbs = $$('[data-thumb]', section);
    const thumbList = $('[data-thumbs]', section);
    if (!track) return;
    const slides = $$('.gallery__slide', track);
    const scrollToSlide = (i) => {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    const dots = $$('[data-gallery-dots] span', section);
    const setActive = (i) => {
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      const active = thumbs[i];
      if (active && thumbList) thumbList.scrollTo({ top: active.offsetTop - thumbList.offsetTop - 40, behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => { const i = Number(t.dataset.thumb); scrollToSlide(i); setActive(i); }));
    track.addEventListener('scroll', () => requestAnimationFrame(() => {
      const w = slides[0] ? slides[0].getBoundingClientRect().width : 1;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      setActive(Math.round(track.scrollLeft / (w + gap)));
    }), { passive: true });
    const up = $('[data-thumbs-up]', section);
    const down = $('[data-thumbs-down]', section);
    if (up) up.addEventListener('click', () => thumbList.scrollBy({ top: -200, behavior: 'smooth' }));
    if (down) down.addEventListener('click', () => thumbList.scrollBy({ top: 200, behavior: 'smooth' }));
    section._scrollToMedia = (mediaId) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i >= 0) { scrollToSlide(i); setActive(i); }
    };
  });

  /* ---------- Variantes e compra ---------- */
  $$('[data-product]').forEach((section) => {
    const jsonEl = $('[data-product-json]', section);
    const form = $('[data-product-form]', section);
    if (!jsonEl || !form) return;
    const data = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const btn = $('[data-add-to-cart]', form);
    const label = $('[data-add-label]', form);
    const errorEl = $('[data-form-error]', section);
    const fieldsets = $$('[data-option-index]', form);

    const selected = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });

    const refreshAvailability = () => {
      const current = selected();
      fieldsets.forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const probe = current.slice();
          probe[idx] = input.value;
          const ok = data.variants.some((v) => v.available && probe.every((val, k) => val === null || v.options[k] === val));
          input.closest('.product-option__value').classList.toggle('is-unavailable', !ok);
        });
      });
    };

    const onChange = () => {
      const opts = selected();
      fieldsets.forEach((fs) => { const c = $('input:checked', fs); const s = $('[data-option-selected]', fs); if (c && s) s.textContent = c.value; });
      const variant = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      refreshAvailability();
      if (!variant) {
        btn.disabled = true;
        label.textContent = 'Indisponível';
        return;
      }
      idInput.value = variant.id;
      btn.disabled = !variant.available;
      label.textContent = variant.available ? data.buttonLabel : 'Esgotado';

      const main = $('[data-price-main]', section);
      const compare = $('[data-price-compare]', section);
      const inst = $('[data-price-installments]', section);
      if (main) main.textContent = formatMoney(pixPrice(variant.price));
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = formatMoney(variant.compare_at_price);
      }
      if (inst) {
        const parts = installments(variant.price);
        inst.innerHTML = T.pixDiscount > 0
          ? `ou <strong>${formatMoney(variant.price)}</strong> no cartão${parts ? ` em até <strong>${parts}</strong> sem juros` : ''}`
          : (parts ? `em até <strong>${parts}</strong> sem juros no cartão` : '');
      }
      const stock = $('[data-stock]', section);
      if (stock) {
        if (!variant.available) stock.innerHTML = '<span class="stock__dot stock__dot--out"></span>Esgotado neste tamanho';
        else if (variant.qty !== null && variant.qty > 0 && variant.qty <= data.lowStock) stock.innerHTML = `<span class="stock__dot stock__dot--low"></span>Corre! Últimas <strong>${variant.qty}</strong> unidades neste tamanho`;
        else stock.innerHTML = '<span class="stock__dot"></span>Em estoque · envio imediato de Blumenau';
      }
      const sp = $('[data-sticky-price]', section);
      const sv = $('[data-sticky-variant]', section);
      if (sp) sp.textContent = formatMoney(pixPrice(variant.price));
      if (sv) sv.textContent = opts.join(' / ');
      if (variant.media_id && section._scrollToMedia) section._scrollToMedia(variant.media_id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };
    fieldsets.forEach((fs) => fs.addEventListener('change', onChange));
    if (fieldsets.length) refreshAvailability();

    const sticky = $('[data-sticky-buy]', section);
    if (sticky && 'IntersectionObserver' in window) {
      const st = { past: false, footer: false };
      const apply = () => {
        const show = st.past && !st.footer;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('has-sticky-buy', show);
      };
      new IntersectionObserver(([entry]) => {
        st.past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        apply();
      }).observe(btn);
      const footer = $('.footer');
      if (footer) new IntersectionObserver(([entry]) => { st.footer = entry.isIntersecting; apply(); }, { rootMargin: '0px 0px -40px 0px' }).observe(footer);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        if (btn.disabled) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        form.requestSubmit ? form.requestSubmit() : btn.click();
      });
    }

    const qtyInput = $('[data-qty-input]', form);
    if (qtyInput) {
      $('[data-qty-minus]', form).addEventListener('click', () => { qtyInput.value = Math.max(1, Number(qtyInput.value) - 1); });
      $('[data-qty-plus]', form).addEventListener('click', () => { qtyInput.value = Number(qtyInput.value) + 1; });
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;
      btn.classList.add('is-loading');
      try {
        await Cart.add([{ id: Number(idInput.value), quantity: qtyInput ? Number(qtyInput.value) : 1 }]);
        Cart.open();
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  });

  /* ---------- Aviso de combo (lado esquerdo) ---------- */
  const Nudge = {
    get el() { return document.getElementById('PromoNudge'); },
    key: 'bp-nudge-min',
    init() {
      const el = this.el;
      if (!el) return;
      const card = el.querySelector('[data-pp-state]');
      let minState = null;
      try { minState = sessionStorage.getItem(this.key); } catch (_) {}
      // No celular começa recolhido (pílula); no computador, aberto — a não ser que a cliente tenha minimizado.
      if ((card && minState === card.dataset.ppState) || window.innerWidth < 750) el.classList.add('is-min');
    },
    isMobile() { return window.innerWidth < 750; },
    autoClose(ms) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { if (this.isMobile() && this.el) this.el.classList.add('is-min'); }, ms);
    },
    async update(html) {
      const el = this.el;
      if (!el) return;
      if (!html) {
        const res = await fetch(`${window.location.pathname}?sections=promo-nudge`, { headers: { Accept: 'application/json' } });
        html = (await res.json())['promo-nudge'];
      }
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('PromoNudge');
      if (!fresh) return;
      const before = el.querySelector('[data-pp-state]');
      const after = fresh.querySelector('[data-pp-state]');
      const changed = (before && before.dataset.ppState) !== (after && after.dataset.ppState);
      el.innerHTML = fresh.innerHTML;
      if (changed && after) {
        if (window.innerWidth >= 750) {
          el.classList.remove('is-min');
        } else {
          // Celular: mostra o progresso por alguns segundos e volta para o círculo.
          el.classList.remove('is-min');
          this.autoClose(3500);
        }
        el.classList.add('is-bump');
        setTimeout(() => el.classList.remove('is-bump'), 700);
      }
    }
  };
  document.addEventListener('click', (e) => {
    const el = Nudge.el;
    if (!el || !el.contains(e.target)) return;
    const card = el.querySelector('[data-pp-state]');
    if (e.target.closest('[data-nudge-close]')) {
      el.classList.add('is-min');
      try { if (card) sessionStorage.setItem(Nudge.key, card.dataset.ppState); } catch (_) {}
    }
    if (e.target.closest('[data-open-combos]')) {
      Cart.forceCombos = true;
      Cart.open();
      Cart.refresh();
      return;
    }
    if (e.target.closest('[data-nudge-open]')) {
      clearTimeout(Nudge.timer);
      el.classList.remove('is-min');
      try { sessionStorage.removeItem(Nudge.key); } catch (_) {}
    }
  });
  Nudge.init();
  // Celular: card aberto fecha ao rolar a página ou tocar fora dele.
  let nudgeScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    const el = Nudge.el;
    if (!el || !Nudge.isMobile() || el.classList.contains('is-min')) { nudgeScrollY = window.scrollY; return; }
    if (Math.abs(window.scrollY - nudgeScrollY) > 60) { el.classList.add('is-min'); clearTimeout(Nudge.timer); }
  }, { passive: true });
  document.addEventListener('click', (e) => {
    const el = Nudge.el;
    if (!el || !Nudge.isMobile() || el.classList.contains('is-min') || el.contains(e.target)) return;
    el.classList.add('is-min');
    clearTimeout(Nudge.timer);
  });
  document.addEventListener('click', (e) => { if (e.target.closest('[data-nudge-open]')) nudgeScrollY = window.scrollY; }, true);
  // Página reaberta pelo "voltar" (cache do navegador) ou sacola alterada em outra aba: atualiza combos e contador.
  const resync = () => { if (window.BasicCart) window.BasicCart.refresh(); else Nudge.update(); };
  window.addEventListener('pageshow', (e) => { if (e.persisted) resync(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) resync(); });

  /* ---------- Sacola lateral (renderizada pela Shopify) ---------- */
  const Cart = {
    get drawer() { return document.getElementById('CartDrawer'); },
    async render(sectionsJson) {
      let html = sectionsJson && sectionsJson['cart-drawer'];
      if (!html) {
        const res = await fetch(`${window.location.pathname}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
        html = (await res.json())['cart-drawer'];
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.cart-drawer__panel');
      const panel = this.drawer && this.drawer.querySelector('.cart-drawer__panel');
      if (fresh && panel) {
        const scroll = panel.querySelector('.cd-body') ? panel.querySelector('.cd-body').scrollTop : 0;
        const combosOpen = this.forceCombos || (panel.querySelector('.cd-combos') && panel.querySelector('.cd-combos').open);
        this.forceCombos = false;
        panel.innerHTML = fresh.innerHTML;
        const combos = panel.querySelector('.cd-combos');
        if (combos && combosOpen) combos.open = true;
        const body = panel.querySelector('.cd-body');
        if (body) body.scrollTop = scroll;
      }
      Nudge.update(sectionsJson && sectionsJson['promo-nudge']);
      const count = doc.querySelector('.cd-head__count');
      if (count) $$('[data-cart-count]').forEach((el) => { el.textContent = count.textContent.trim(); });
    },
    async refresh() { await this.render(); },
    async add(items) {
      const res = await fetch(T.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'cart-drawer,promo-nudge', sections_url: window.location.pathname })
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Não foi possível adicionar.');
      await this.render(json.sections);
      return json;
    },
    async change(key, quantity) {
      const res = await fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer,promo-nudge', sections_url: window.location.pathname })
      });
      const json = await res.json();
      if (!res.ok) { toast(json.description || json.message || 'Não foi possível alterar a quantidade.'); await this.render(); return; }
      await this.render(json.sections);
    },
    open() { openDrawer(this.drawer); }
  };
  window.BasicCart = Cart;

  document.addEventListener('click', (e) => {
    const drawer = Cart.drawer;
    if (!drawer || !drawer.contains(e.target)) return;
    const row = e.target.closest('[data-key]');
    if (!row) return;
    const input = $('[data-cart-input]', row);
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) { row.classList.add('is-loading'); Cart.change(row.dataset.key, Math.max(0, Number(input.value) + Number(qtyBtn.dataset.cartQty))); }
    if (e.target.closest('[data-cart-remove]')) { row.classList.add('is-loading'); Cart.change(row.dataset.key, 0); }
  });
  document.addEventListener('change', (e) => {
    if (!e.target.matches('#CartDrawer [data-cart-input]')) return;
    const row = e.target.closest('[data-key]');
    row.classList.add('is-loading');
    Cart.change(row.dataset.key, Math.max(0, Number(e.target.value)));
  });
  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', async (e) => {
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    Cart.open();
    Cart.refresh();
  }));

  /* ---------- Compra rápida (cards, vídeos, sacola) ---------- */
  document.addEventListener('click', async (e) => {
    const toggle = e.target.closest('[data-quick-toggle]');
    if (toggle) {
      const card = toggle.closest('.pcard');
      $$('.pcard.is-quick').forEach((c) => { if (c !== card) c.classList.remove('is-quick'); });
      card.classList.toggle('is-quick');
      return;
    }
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try {
      await Cart.add([{ id: Number(btn.dataset.quickAdd), quantity: 1 }]);
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1200);
      const card = btn.closest('.pcard');
      if (card) card.classList.remove('is-quick');
      Cart.open();
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.title = err.message;
      toast(err.message);
      btn.classList.add('is-error'); setTimeout(() => btn.classList.remove('is-error'), 2500);
    }
  });

  /* ---------- Checkout: sempre pela Yampi (nunca o checkout nativo) ---------- */
  const isCheckoutPath = (href) => {
    try { return /^\/(checkout|checkouts)(\/|$)/.test(new URL(href, window.location.href).pathname); } catch (e) { return false; }
  };
  let checkoutTries = 0;
  const goCheckout = () => {
    if (typeof window.yampiClick === 'function') {
      window.yampiClick();
      // se a Yampi não responder, libera a tela em vez de deixar o carregamento travado
      clearTimeout(goCheckout.guard);
      goCheckout.guard = setTimeout(() => {
        const loader = document.querySelector('.yampi-loader');
        if (loader) loader.style.display = 'none';
        toast('O checkout está demorando para abrir. Tente novamente em instantes.');
      }, 15000);
      return;
    }
    // script da Yampi ainda não carregou: espera um pouco e tenta de novo; nunca envia para /checkout
    if (checkoutTries++ < 10) { setTimeout(goCheckout, 300); return; }
    checkoutTries = 0;
    if (document.body.classList.contains('template-cart')) toast('Não foi possível abrir o checkout. Atualize a página e tente novamente.');
    else window.location.href = (T.routes && T.routes.cart) || '/cart';
  };
  // Na página do carrinho, o script da Yampi redireciona sozinho; se ela não responder, libera a tela
  if (document.body.classList.contains('template-cart')) {
    setTimeout(() => {
      const loader = document.querySelector('.yampi-loader');
      if (loader && getComputedStyle(loader).display !== 'none') {
        loader.style.display = 'none';
        toast('O checkout está demorando para abrir. Toque em Finalizar compra para tentar de novo.');
      }
    }, 15000);
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-checkout]');
    const link = !btn && e.target.closest('a[href]');
    if (btn || (link && isCheckoutPath(link.getAttribute('href')))) {
      e.preventDefault();
      e.stopPropagation();
      goCheckout();
    }
  }, true);
  document.addEventListener('submit', (e) => {
    const sub = e.submitter;
    const action = e.target.getAttribute('action') || '';
    if ((sub && sub.name === 'checkout') || isCheckoutPath(action)) {
      e.preventDefault();
      goCheckout();
    }
  }, true);

  /* ---------- Rodapé: colunas em sanfona só no mobile ---------- */
  const footerCols = $$('.footer__col');
  const syncFooter = () => footerCols.forEach((d) => { d.open = window.innerWidth > 989; });
  footerCols.forEach((d) => d.querySelector('summary').addEventListener('click', (e) => { if (window.innerWidth > 989) e.preventDefault(); }));
  syncFooter();
  let footerW = window.innerWidth;
  window.addEventListener('resize', () => { if ((footerW > 989) !== (window.innerWidth > 989)) syncFooter(); footerW = window.innerWidth; });

  /* ---------- Coleção: ordenação e filtros ---------- */
  const sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const params = new URLSearchParams();
      new FormData(filterForm).forEach((value, key) => { if (value !== '') params.append(key, value); });
      window.location.search = params.toString();
    });
  }

  /* ---------- Produtos relacionados ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        $$('[data-carousel]', el).forEach(initCarousel);
      }
    } catch (_) { /* sem recomendações */ }
  });
})();
